import { render, staticRenderFns } from "./MaleRecommends.vue?vue&type=template&id=031693f9&scoped=true"
import script from "./MaleRecommends.vue?vue&type=script&lang=js"
export * from "./MaleRecommends.vue?vue&type=script&lang=js"
import style0 from "./MaleRecommends.vue?vue&type=style&index=0&id=031693f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031693f9",
  null
  
)

export default component.exports